import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { ToastrComponent } from '../util/toastr/toastr.component';
import { Router } from '@angular/router';
import { Misc } from '../util/misc';
import { UsuarioService } from 'src/app/services/usuario.service';
import { Usuario } from 'src/app/models/usuario.model';
import { UnidadeService } from 'src/app/services/unidade.service';
import { Unidade } from 'src/app/models/unidade.model';
import { UtilService } from 'src/app/services/util.service';

@Component({
  selector: 'app-register-user',
  templateUrl: './register-user.component.html',
  styleUrls: ['./register-user.component.scss']
})
export class RegisterUserComponent implements OnInit {

  constructor(
    private route: Router,
    private usuarioService: UsuarioService,
    private fb: UntypedFormBuilder,
    public misc: Misc,
    private toastr: ToastrComponent,
    private unidadeService: UnidadeService,
    private utilService: UtilService
  ) { }

  usuario: Usuario;
  formUser: UntypedFormGroup;
  loading = false;
  unidades: Unidade[];
  filtroUnidade: Array<Unidade> = [];

  ngOnInit() {
    if (!this.utilService.isAdmin()) {
      this.utilService.redirectAcessoNegado();
    }

    this.createForm();
  }

  createForm() {
    this.formUser = this.fb.group({
      id: [0],
      login: ['', Validators.required],
      senha: ['', Validators.required],
      email: [''],
      tb_usuario_perfil: ['', Validators.required],
      unidade: ['', Validators.required]
    });

    this.carregaDropDownUnidades();
  }

  register() {
    this.loading = true;
    const usuarioForm: Usuario = this.formUser.value;
    const perfId = Number(usuarioForm.tb_usuario_perfil);
    const unidadeId = Number(usuarioForm.unidade);

    this.usuario = {
      id: usuarioForm.id,
      login: usuarioForm.login,
      email: usuarioForm.email,
      senha: usuarioForm.senha,
      ativo: true,
      dtAlteracao: new Date(),
      dtInclusao: new Date(),
      tb_usuario_perfil: [{
        usuarioId: usuarioForm.id,
        perfilId: perfId
      }
      ],
      unidadeId: unidadeId
    };

    this.usuarioService.add(this.usuario)
      .subscribe(
        result => {
          if (result === null) {
            this.toastr.mostrarMensagem('aviso', 'Atenção', `Usuário já existente: ${this.usuario.login}`);
            return;
          } else {
            this.toastr.mostrarMensagem('sucesso', 'Sucesso', 'Registro incluído com sucesso');
            this.route.navigate(['/cadastro/usuario-list']);
          }
        },
        error => {
          this.misc.processError(error, 'Não foi possível registrar o usuário.');
        },
        () => {
          this.loading = false;
        }
      );
  }

  cancel() {
    this.route.navigate(['/cadastro/usuario-list']);
  }

  carregaDropDownUnidades() {
    this.unidadeService.getAllAtivos().subscribe((result: any) => {
      this.unidades = result.items;

      this.unidades.forEach(element => {
        let unidade = new Unidade;
        unidade.id = element.id;
        unidade.nome = element.nome;
        this.filtroUnidade.push(unidade);
      });

      this.filtroUnidade.sort((a, b) => (a.nome.trim().toLowerCase() < b.nome.trim().toLowerCase() ? -1 : 1));
    })
  }
}